import { render } from "./RightSidebarLayout.vue?vue&type=template&id=7d411bad"
import script from "./RightSidebarLayout.vue?vue&type=script&lang=js"
export * from "./RightSidebarLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/layouts/instructor/RightSidebarLayout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7d411bad"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7d411bad', __exports__)) {
    api.reload('7d411bad', __exports__)
  }
  
  module.hot.accept("./RightSidebarLayout.vue?vue&type=template&id=7d411bad", () => {
    api.rerender('7d411bad', render)
  })

}


export default __exports__